import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { CSidebar, CSidebarBrand, CSidebarNav } from '@coreui/react'

import { AppSidebarNav } from './AppSidebarNav'

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'
import JT from '../Images/JT .png'

import navigation from '../_nav'

const AppSidebar = () => {
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow)

  return (
    <CSidebar
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch({ type: 'set', sidebarShow: visible })
      }}
    >
      <CSidebarBrand className="d-none d-md-flex" to="/">
        <img src={JT} alt="" style={{width: "40px"}}/>
        <h5 className='mb-0 ms-2'>D3 Showcase</h5>
      </CSidebarBrand>
      <CSidebarNav style={{background: '#303c54'}}>
        {/* <SimpleBar> */}
          <AppSidebarNav items={navigation} className="my-items" />
        {/* </SimpleBar> */}
      </CSidebarNav>
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
